











import Vue from 'vue'
import { TheBrand } from './components'

export default Vue.extend({
    name: 'TheAppBar',

    components: { TheBrand },

    computed: {
        isMobile(): boolean {
            return this.$vuetify.breakpoint.xsOnly
        },
    },
})
